import { HeadingLevel, NodeAlign, RowType, fallbackTextContent } from '@getaccept/editor-lib-new';
import { computed, defineComponent } from 'vue';
import { CreateContextualCommentButtonState } from '@getaccept/lib-shared-new/src/contextual-commenting/types/create-contextual-comment-button-state';
import DetachedCommentAnchor from '@getaccept/lib-shared-new/src/contextual-commenting/components/DetachedCommentAnchor.vue';
import ProsemirrorViewerText from './ProsemirrorViewerText.vue';
import EditorNodeWrapper from './EditorNodeWrapper.vue';
export default defineComponent({
    name: 'EditorNodeText',
    components: {
        DetachedCommentAnchor,
        ProsemirrorViewerText,
        EditorNodeWrapper,
    },
    props: {
        node: {
            type: Object,
            default: () => ({}),
        },
        mergeValues: { type: Object, required: true },
        hasLinkNode: { type: Boolean, default: false },
        rowType: { type: String, default: RowType.Standard },
        parentFirstChild: { type: Boolean, default: false },
        parentLastChild: { type: Boolean, default: false },
        blockWidthClass: { type: String, default: null },
        comments: { type: Array, default: () => [] },
        selectedCommentId: { type: String, default: '' },
        showContextualComments: { type: Boolean, default: false },
        createContextualCommentButtonState: {
            type: String,
            default: CreateContextualCommentButtonState.Enabled,
        },
    },
    emits: ['observe-node-visibility', 'create-comment', 'select-comment'],
    setup(props) {
        const fields = computed(() => { var _a; return ((_a = props.node) === null || _a === void 0 ? void 0 : _a.fields) || []; });
        const rowTypeClass = computed(() => { var _a; return `row-type-${(_a = props.rowType) === null || _a === void 0 ? void 0 : _a.toLowerCase()}`; });
        const commentsWithTextSelection = computed(() => props.comments.filter(comment => { var _a; return (_a = comment.editorSelection) === null || _a === void 0 ? void 0 : _a.textSelection; }));
        const commentsWithoutTextSelection = computed(() => props.comments.filter(comment => { var _a; return !((_a = comment.editorSelection) === null || _a === void 0 ? void 0 : _a.textSelection); }));
        const isLayoutRow = computed(() => [RowType.Columns, RowType.SideBySide].includes(props.rowType));
        const defaultHeading = computed(() => isLayoutRow.value ? HeadingLevel.Heading2 : HeadingLevel.Heading1);
        const defaultAlign = computed(() => RowType.Columns === props.rowType ? NodeAlign.Center : NodeAlign.Left);
        const jsonContent = computed(() => {
            const contentToParse = isMarkdownField.value
                ? markdownField.value.value
                : props.node.content || fallbackTextContent;
            return JSON.parse(contentToParse);
        });
        const isMarkdownField = computed(() => Boolean(props.node.markdownFieldId));
        const markdownField = computed(() => fields.value.find(field => field.id === props.node.markdownFieldId) ||
            { value: null });
        return {
            commentsWithTextSelection,
            commentsWithoutTextSelection,
            fields,
            rowTypeClass,
            isLayoutRow,
            defaultHeading,
            defaultAlign,
            jsonContent,
        };
    },
});
